function handleDisplayChange(mutationsList, observer) {
  for(let mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
      const pageSkipLink = document.querySelector('.PageSkipLink');
      const pageContainer = document.querySelector('.PageContainer');
      const cookieConsentBanner = document.querySelector('[aria-describedby="cookieconsent:desc"]')

      if(mutation.target.style.display !== 'none'){
        setAriaHiddenAttributeTrue(pageSkipLink)
        setAriaHiddenAttributeTrue(pageContainer);
        setAriaHiddenAttributeTrue(cookieConsentBanner);
      } else {
        removeAriaHiddenAttributeTrue(pageSkipLink)
        removeAriaHiddenAttributeTrue(pageContainer);
        removeAriaHiddenAttributeTrue(cookieConsentBanner);
      }
    }
  }
}

let cookieObserverTimeout;

function handleCookieMutation(mutationsList, cookieObserver) {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // Check if the element with ID "cookieconsent:settings" is present
      const cookieConsentModal = document.getElementById('cookieconsent:settings');
      if (cookieConsentModal) {
        clearTimeout(cookieObserverTimeout); // Cancel the fallback
        const observer = new MutationObserver(handleDisplayChange);
        const config = { attributes: true, attributeFilter: ['style'] };
        observer.observe(cookieConsentModal, config);
        cookieObserver.disconnect();
      }
    }
  }
}

function onTabChange() {
  const flashPage = document.getElementById('flash-page-title');

  if(!flashPage) return;

  const dynamicHeadings = flashPage.dataset.dynamicHeadings;
  
  if(dynamicHeadings.length < 1) return ;

  const dynamicTitlesFormatted = dynamicHeadings.split('|');
  const defaultTitle = flashPage.dataset.defaultTitle;

  var headings = dynamicTitlesFormatted;
	var i = 0;
	var intervalId = setInterval(function() {
		document.title = `${headings[i]} ${defaultTitle}`;
		if (i == (headings.length - 1)) {
			i = 0;
		} else {
			i++;
		}
		if(document.hasFocus()) {
			document.title = defaultTitle;
			clearInterval(intervalId);
		}
	}, 2000);
}

function onTabRevisit() {
  const flashPage = document.getElementById('flash-page-title');

  if(!flashPage) return;

  const defaultTitle = flashPage.dataset.defaultTitle;

	document.title = defaultTitle;
}

function queryAjaxPost(endpoint, payload) {
  return fetch(endpoint, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: payload
  }).then(function (response) {
      if (response.status === 200) {
          return response.json();
      }
  }).catch((error) => {
      console.error('Error:', error);
  });
}

function setFlickityDotsAriaLabels() {
  // Function to process dots
  function processDots() {
    
    const flickitySliders = document.querySelectorAll('.flickity-viewport')
    const themeTranslations = window.languages;

    if(!flickitySliders) return; 
    flickitySliders.forEach(slider => {
      const dots = slider.parentElement.querySelectorAll('.flickity-page-dots .dot');
      const isSwatchGroup = slider.parentElement.classList.contains('ColorSwatchList')

      if (!dots) return;

      if(isSwatchGroup){
        const previousButton = slider.parentElement.querySelector('.flickity-prev-next-button.previous')
        const nextButton = slider.parentElement.querySelector('.flickity-prev-next-button.next')

        previousButton.setAttribute('aria-label', themeTranslations.previousSwatchGroup);
        nextButton.setAttribute('aria-label', themeTranslations.nextSwatchGroup);
      }

      if(slider.parentElement.classList.contains('SwatchCarousel')){
        if(slider.parentElement.hasAttribute('tabindex')){
          slider.parentElement.removeAttribute('tabindex')
        }
      }

      dots.forEach((dot, dotIndex) => {
        if (!dot.hasAttribute('tabindex')) {
          const dotsContainer = dot.closest('.flickity-page-dots');
          const flickitySlides = dotsContainer ? dotsContainer.parentElement.querySelector('.flickity-viewport .flickity-slider') : null;
          const currentSlide = flickitySlides ? flickitySlides.children[dotIndex] : null;
          const currentSlideImage = currentSlide ? currentSlide.querySelector('img') : null;
          const imageAlt = currentSlideImage ? currentSlideImage.getAttribute('alt') : '';
          let textInfo = '';
          if(isSwatchGroup){
            textInfo = `${themeTranslations.swatchGroup}${dotIndex + 1}`
          } else {
            textInfo = imageAlt.length ? `${themeTranslations.slideAlt}${imageAlt}${themeTranslations.onSlide}${dotIndex + 1}` : `${themeTranslations.emptyAlt}${dotIndex + 1}`;
          }
          
          const srSpan = document.createElement('span');
          srSpan.className = 'sr-only';
          srSpan.textContent = textInfo;
          
          // Add aria-label and screen reader text
          dot.setAttribute('aria-label', textInfo);
          dot.setAttribute('tabindex', '0');
          dot.setAttribute('role', 'listitem');
          dot.appendChild(srSpan);

          // Add keyboard event listener
          dot.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const slider = dot.closest('.flickity-enabled');
              if (slider) {
                const flickitySlider = Flickity.data(slider);
                if (flickitySlider) {
                  flickitySlider.select(dotIndex);
                }
              }
            }
          });
        }
      });
    });
  }

  // Initial processing
  processDots();
  
  // The tabindex guard in processDots() prevents re-processing,
  // so we only need to run this once after Flickity initializes.
  // No need for expensive full-DOM MutationObserver.
}

function setArrowSvgRoles() {
  const arrowSvgs = document.querySelectorAll('.flickity-prev-next-button');
  
  arrowSvgs.forEach(svg => {
    const slider = svg.closest('.flickity-enabled');

    if (!slider) return;

    try {
      const flickitySlider = Flickity.data(slider);      
      if (!flickitySlider) return;

      const buttons = flickitySlider.element.querySelectorAll('svg:has(.arrow)');
      if(!buttons) return;

      buttons.forEach(button => {
        button.setAttribute('role', 'presentation');
      });
      
    } catch (error) {
      console.error('Error in setArrowSvgRoles:', error);
    }
  });
}

function handleCurrencyModal() {
  const modals = [
    {
      background: document.querySelector('.bundle-product-modal:has(#currency-modal)'),
      modal: document.getElementById('currency-modal'),
      button: document.querySelector('[data-action="open-modal"][data-modal-id="currency-modal"]')
    },
    {
      background: document.querySelector('.bundle-product-modal:has(#side-bar-currency-modal)'),
      modal: document.getElementById('side-bar-currency-modal'),
      button: document.querySelector('[data-action="open-modal"][data-modal-id="side-bar-currency-modal"]')
    }
  ];

  function getFocusableElements(modalEl) {
    return modalEl.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  }
  
  function openModal(bundleEl, modalEl) {
    bundleEl.setAttribute('aria-hidden', 'false');
    modalEl.style.visibility = 'visible';
    modalEl.style.opacity = '1';
    document.body.style.overflow = 'hidden';
    
    // Focus on first focusable element
    const focusableElements = getFocusableElements(modalEl);    
    // Add a small delay to ensure modal is fully visible
    setTimeout(() => {
      if (focusableElements.length > 0) {
        const firstFocusable = focusableElements[0];
        firstFocusable.focus();
      }
    }, 100);
  }
  
  function closeModal(bundleEl, modalEl) {
    bundleEl.setAttribute('aria-hidden', 'true');
    modalEl.style.visibility = 'hidden';
    modalEl.style.opacity = '0';
    document.body.style.overflow = '';
  }
  
  function handleEscapeKey(event) {
    if (event.key === 'Escape') {
      modals.forEach(({ background, modal }) => {
        if (background && background.getAttribute('aria-hidden') === 'false') {
          closeModal(background, modal);
        }
      });
    }
  }

  function handleTabKey(event, modalEl) {
    const focusableElements = getFocusableElements(modalEl);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (event.key === 'Tab') {
      if (event.shiftKey && document.activeElement === firstFocusableElement) {
        event.preventDefault();
        lastFocusableElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusableElement) {
        event.preventDefault();
        firstFocusableElement.focus();
      }
    }
  }

  function setupModalListeners({ background, modal, button }) {
    if (!background || !modal || !button) return;

    button.addEventListener('click', () => openModal(background, modal));
    
    const closeButton = background.querySelector('[data-action="close-modal"]');
    if (closeButton) {
      closeButton.addEventListener('click', () => closeModal(background, modal));
    }
    
    const saveCurrencyButton = background.querySelector('[data-action="save-currency"]');
    if (saveCurrencyButton) {
      saveCurrencyButton.addEventListener('click', () => closeModal(background, modal));
    }
    
    background.addEventListener('click', (event) => {
      if (event.target === background) {
        closeModal(background, modal);
      }
    });

    modal.addEventListener('keydown', (e) => handleTabKey(e, modal));
  }

  // Setup listeners for all modals
  modals.forEach(setupModalListeners);
  
  // Global escape key handler
  document.addEventListener('keydown', handleEscapeKey);
}

function handleSwatchAccessibility() {
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
      const target = event.target;
      if (target.classList.contains('SwatchCarousel__ModalSwatch')) {
        event.preventDefault();
        // Find the label inside the swatch and trigger a click on it
        const label = target.querySelector('.ColorSwatchLabel');
        if (label) {
          label.click();
        }
      } else if (target.classList.contains('ColorSwatchLabel')) {
        event.preventDefault();
        // Directly click the label
        target.click();
      } else if (target.classList.contains('HorizontalList__Item')) {
        event.preventDefault();
        // Find the label inside the list item and trigger a click on it
        const label = target.querySelector('.ColorSwatchLabel');
        if (label) {
          label.click();
        }
      }
    }
  });
}

const BUNDLE_TYPES = ['Bundle Product', 'Pattern', 'Kit', 'Marketplace Pattern'];

async function handleBundleCheck() {
  const bundleTypes = BUNDLE_TYPES;

  let cartResponse = await fetch('/cart.js', {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    },
  }).then((response) => {
    return response.json();
  });

  if(cartResponse) {
    let payload = {
      updates: {}
    };
    const bundleCartItems = cartResponse.items.filter(cartItem => bundleTypes.includes(cartItem.product_type) || cartItem.properties.hasOwnProperty('Bundle'));

    if(bundleCartItems.length < 1) return;

    bundleCartItems.forEach(cartItem => {
      // Check for bundle items. They the property _bundle_key should have atleast a quantity of 2.
      // If the quantity is 1, that means a bundle was somehow added without any other items.
      if(cartItem.properties.hasOwnProperty('_bundle_key')) {
        const currentBundleKey = cartItem.properties['_bundle_key'];

        const currentBundleItems = bundleCartItems.filter(bci => bci.properties['_bundle_key'] === currentBundleKey);
        const currentBundleParent = bundleCartItems.find(bci => bundleTypes.includes(bci.product_type) && bci.properties['_bundle_key'] === currentBundleKey);
        if(currentBundleItems.length < 2 || !currentBundleParent) {
          payload.updates[cartItem.key] = 0;
        }
      // If ATC is enabled through Accencuate, users will be able to add premium patterns to their cart
      // these patterns should never be free.
      } else {
        if(cartItem.price <= 0) {
          payload.updates[cartItem.key] = 0;
        }
      }
    });


    if(Object.keys(payload.updates).length > 0){
      await queryAjaxPost('/cart/update.js', JSON.stringify(payload)).then(() => {
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: - (Object.keys(payload.updates).length)
          }
        }));
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", async () => {
  const observer = new MutationObserver(handleDisplayChange);
  const cookieObserver = new MutationObserver(handleCookieMutation);
  const wishlistRemoveModal = document.getElementById('remove_modal');
  const wishlistRemoveAllModal = document.getElementById('remove_all_modal');
  const config = { attributes: true, attributeFilter: ['style'] };

  handleBundleCheck();
  
  if(wishlistRemoveModal){
    observer.observe(wishlistRemoveModal, config);
  }
  if(wishlistRemoveAllModal){
    observer.observe(wishlistRemoveAllModal, config);
  }

  // Narrow scope — cookie banners are direct body children
  cookieObserver.observe(document.body, {
    childList: true,
    subtree: false
  });

  // Fallback: always disconnect after 5 seconds
  cookieObserverTimeout = setTimeout(() => {
    cookieObserver.disconnect();
  }, 5000);

  window.addEventListener("blur", onTabChange);
  window.addEventListener("focus", onTabRevisit);

  // Run after Flickity initializes (500ms is sufficient for most cases)
  setTimeout(setFlickityDotsAriaLabels, 500);
  handleCurrencyModal();
  handleSwatchAccessibility();

  document.addEventListener('product:added', async (event) => {
    const type = event.detail && event.detail.product_type;
    // Skip if this product is clearly not a bundle type
    if (type && !BUNDLE_TYPES.includes(type)) return;
    // Skip if there is no bundle form on this page
    if (!document.getElementById('bundled-product-form')) return;
    await handleBundleCheck();
  });
  setTimeout(setArrowSvgRoles, 1000);
});
